import React from 'react';
import { useProductsWrapperInfinite } from 'modules/page-builder/hooks/usePbProducts';
import { ProductGrid } from '@teko/teko-ecommerce';
import { useTenantConfig } from 'hooks';
import { t } from 'i18n';
import { SlotComponentProps } from 'modules/page-builder/types';
import { SearchProductPagination } from '@teko/discovery';
import { Shape, Button, Flex, styled } from '@teko/ds-desktop';
import { ThemeProps } from '@teko/ui';
import { ProductCardProps } from '@teko/types/ecommerce';
import { LazyComponent } from 'components/LazyComponent';

export type ProductGridProps = SlotComponentProps<{
  products: ProductCardProps[];
  pagination?: SearchProductPagination;
}>;

export const ProductGridDesktopSlot: React.FC<ProductGridProps> = ({
  collectionSlug,
  serverData,
}: ProductGridProps) => {
  const { contactLink } = useTenantConfig();

  const [{ products, hasMore, loading }, { onNextPage }] =
    useProductsWrapperInfinite(collectionSlug ?? '', {
      initialValue: serverData,
      limit: 40,
    });

  return products ? (
    <Shape backgroundColor="#f6f6f6">
      <ProductGrid
        products={products}
        regionName="forYouListProduct"
        contactLink={contactLink}
        productsPerRow={5}
      />
      {hasMore && (
        <Flex justify="center" marginTop="s16">
          <Button
            backgroundColor="#fff"
            width={340}
            onClick={onNextPage}
            variant="white-ghost"
            color="#000000"
            marginBottom="s8"
            disabled={loading}
          >
            {loading && <Spinner />}
            {t('Xem thêm')}
          </Button>
        </Flex>
      )}
    </Shape>
  ) : null;
};

export const Spinner = styled.div<ThemeProps>(
  ({ theme }) => `
  border: 3px solid ${theme.colors.blue100};
  border-top-color: ${theme.colors.blue500};
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  margin: 0 0.5rem;
  animation: spin 1s linear infinite;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`,
);

export const LazyProductGridDesktopSlot: React.FC<ProductGridProps> = (
  props,
) => {
  return (
    <LazyComponent>
      <ProductGridDesktopSlot {...props} />
    </LazyComponent>
  );
};
